enum CensusTabValue {
  Personal,
  Dependents,
  Beneficiaries,
  Enrollments,
  Files,
}

export default CensusTabValue;
